import React from 'react'
import { Model, WhenModel } from '@morningtrain/react-resources'
import { Text } from '@morningtrain/react-displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import { Link } from '@morningtrain/react-navigation'
import Button from 'ui/buttons/Button'
import * as Displays from 'support/displays'

export default function ViewCustomerSmartview (props) {
  return (
    <Smartview header='Kundeinformation'>
      <Model resourceName='customers' id={props.id}>

        <WhenModel>
          <SmartviewTextGroup>
            <SmartviewText label='Virksomhedsnavn'>
              <Text name='name' />
            </SmartviewText>
            <SmartviewText label='Kundenr.'>
              <Text name='customer_number' />
            </SmartviewText>
            <SmartviewText label='CVR'>
              <Text name='cvr' />
            </SmartviewText>
            <SmartviewText label='Adresse'>
              <Text name='address' />, <Text name='zipcode' /> <Text name='city' />
            </SmartviewText>
            <SmartviewText label='Kontaktperson'>
              <Text name='contact.name' />
            </SmartviewText>
            <SmartviewText label='Email'>
              <Text name='email' />
            </SmartviewText>
            <SmartviewText label='Impersonate'>
              <Link route='app.users.users.impersonate_user' parameters={{ user: 'model:contact_id' }}>
                <Button text='Impersonate kontaktperson' />
              </Link>
            </SmartviewText>
          </SmartviewTextGroup>

          <SmartviewContentSeparator />
        </WhenModel>

        <Link route='app.customers.edit' parameters={{ customer: props.id }}>
          <Button text='Rediger' />
        </Link>

      </Model>
    </Smartview>
  )
}
